import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import {
  Badge,
  Btn,
  CustomCard,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  CustomDropdown,
  CustomTabView,
  CustomInputTextArea,
  CustomModal,
  TextBtn,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import * as colors from '../../../../assets/js/colors'
import useGerenciamentoPosicoesEstoque, { LOAD_MESSAGE } from './GerenciamentoPosicoesEstoqueHook'
import { TabPanel } from 'primereact/tabview'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import PalletAreaStatus from '../../../../constants/pallet-area-status'
import { Fieldset } from 'primereact/fieldset'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'

function CadastroPosicoesEstoque({ selectedTp, history, dispatch }) {
  const { state, localDispatch } = useGerenciamentoPosicoesEstoque()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.GET_ESTOQUE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getEstoque(selectedTp)
        break
      case LOAD_MESSAGE.GET_POSICOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPosicoesEstoque(selectedTp, state.selectedEstoque.id)
        break
      case LOAD_MESSAGE.GET_MOTIVOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getMotivosBloqueioPosicao(selectedTp)
        break
      case LOAD_MESSAGE.GET_HISTORICO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.historicoPosicaoEstoque(selectedTp, state.selectedPosicao)
        break
      case LOAD_MESSAGE.GET_PALLETS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPalletsStatus(state.selectedPosicaoEstoque.id)
        break
      case LOAD_MESSAGE.BLOQUEAR_POS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.bloquearPosicoesEstoque(
          selectedTp,
          state.selectedEstoque,
          state.posicoes.filter(p => p.selected),
          state.selectedMotivo,
          state.justificativa,
        )
        break
      case LOAD_MESSAGE.DESBLOQUEAR_POS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.desbloquearPosicoesEstoque(
          selectedTp,
          state.posicoes.filter(p => p.selected),
        )
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox(state.loadingMessage, null))
        localDispatch.resetState()
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(hideLoadingBox())
      dispatch(showMessageBox(state.successMessage, null))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  function TrueOrFalseIconSetter(value) {
    if (value)
      return (
        <div>
          <i className="pi pi-check"></i>
          <span style={{ marginLeft: 5 }}>{value}</span>
        </div>
      )
    else
      return (
        <div>
          <i className="pi pi-times"></i>
          <span style={{ marginLeft: 5 }}>Não</span>
        </div>
      )
  }

  const onBtnExportarExcelClick = () => {
    if (!state.selectedEstoque) {
      dispatch(showMessageBox(null, 'Selecione um estoque antes de exportar'))
      return
    }

    const colunas = []
    colunas.push(['Quant. Posições', state.qtePosicoes])
    colunas.push(['Posições Ocupadas', state.qtePosicoesOcupadas])
    colunas.push(['Posições Disponíveis', state.qtePosicoes - state.qtePosicoesOcupadas])
    colunas.push(['Taxa Ocupação', state.taxaOcupacao])
    colunas.push(['Posições Bloqueadas', state.qtePosicoesBloqueadas])
    colunas.push(['Posições em Expedição', state.posicoesEmExpedicao])
    colunas.push(['Posições em Inventario', state.posicoesEmInventario])
    colunas.push([])

    colunas.push([
      'Sequencia',
      'Endereço',
      'Capacidade',
      'Expedição',
      'Inventario',
      'Status',
      'Ocupação',
      'Empresa(s)',
    ])

    state.posicoes.forEach(p => {
      colunas.push([
        p.sequencia,
        p.endereco,
        p.capacidade,
        p.expedicaoName ? `${p.expedicaoName}` : 'Não',
        p.inventarioName ? 'Sim' : 'Não',
        p.status,
        p.caixas ? 'Ocupado' : 'Vazio',
        p.companies || '-',
      ])
    })

    const titulo = 'PosicoesEstoque'
    gerarArquivoExcel(titulo, colunas, `${titulo}.xlsx`)
  }

  return (
    <>
      <PageHeader>8.14 - Gerenciamento de Posições de Estoque</PageHeader>
      <CustomPanel
        onNovo={() => localDispatch.onBtnNovo(selectedTp)}
        showBtnNovo={false}
        onVoltar={history.goBack}
      >
        <div
          style={{ display: 'flex', gap: '10px', marginTop: 10, marginBottom: 10, marginLeft: 3 }}
        >
          <div style={{ width: 300 }}>
            <CustomDropdown
              disabled={!selectedTp}
              optionLabel="name"
              labelPosition="left"
              options={state.estoques}
              value={state.selectedEstoque}
              label="Estoque"
              filter={false}
              onChange={value => localDispatch.onChange('selectedEstoque', value)}
            />
          </div>
          {state.activeIndex === 2 && (
            <div style={{ width: 300 }}>
              <CustomDropdown
                disabled={!selectedTp || !state.selectedEstoque}
                optionLabel="endereco"
                labelPosition="left"
                options={state.posicoes}
                value={state.selectedPosicaoEstoque}
                label="Posições"
                filter={true}
                onChange={value => localDispatch.onChange('selectedPosicaoEstoque', value)}
              />
            </div>
          )}
        </div>
        <CustomTabView
          activeIndex={state.activeIndex}
          onTabChange={value => localDispatch.onChange('activeIndex', value)}
        >
          <TabPanel header="Status" disabled={!selectedTp}>
            <div style={{ marginTop: 20 }}>
              <div className="p-grid">
                <div className="p-col-3 p-mt-4">
                  <CustomCard title="Quant. Posições" subTitle="Posições Pallets">
                    {state.qtePosicoes}
                  </CustomCard>
                </div>
                <div className="p-col-3 p-mt-4">
                  <CustomCard title="Posições Ocupadas" subTitle="Qte Posições Pallets Ocupadas">
                    {state.qtePosicoesOcupadas}
                  </CustomCard>
                </div>
                <div className="p-col-3 p-mt-4">
                  <CustomCard
                    title="Posições Disponíveis"
                    subTitle="Qte Posições Pallets Disponíveis"
                  >
                    {state.qtePosicoes - state.qtePosicoesOcupadas}
                  </CustomCard>
                </div>
                <div className="p-col-3 p-mt-4">
                  <CustomCard title="Taxa Ocupação" subTitle="Taxa de Ocupação do Estoque">
                    {state.taxaOcupacao}
                  </CustomCard>
                </div>
                <div className="p-col-4 p-mt-4">
                  <CustomCard title="Posições Bloqueadas" subTitle="Qte de Posições Bloqueadas">
                    {state.qtePosicoesBloqueadas}
                  </CustomCard>
                </div>
                <div className="p-col-4 p-mt-4">
                  <CustomCard title="Posições em Expedição" subTitle="Qte de Posições em Expedição">
                    {state.posicoesEmExpedicao}
                  </CustomCard>
                </div>
                <div className="p-col-4 p-mt-4">
                  <CustomCard
                    title="Posições em Inventario"
                    subTitle="Qte de Posições em Inventario"
                  >
                    {state.posicoesEmInventario}
                  </CustomCard>
                </div>
                <div className="p-col-12 mt-4">
                  <Btn
                    disabled={!selectedTp}
                    onClick={onBtnExportarExcelClick}
                    style={{ display: 'inline-block', marginLeft: 16 }}
                  >
                    Exportar Excel
                  </Btn>
                </div>
                <div className="p-col-12">
                  <DataTable
                    value={state.posicoes}
                    emptyMessage="Não existe posição cadastrada"
                    loading={state.isLoading}
                    rows={10}
                    paginator={true}
                    header={
                      <CustomDataTableHeader
                        onChange={value => localDispatch.onChange('globalFilter', value)}
                      />
                    }
                    globalFilter={state.globalFilter}
                  >
                    <Column
                      header="#"
                      style={tableCellCentered(80)}
                      body={item => (
                        <CustomCheckbox
                          checked={item.selected === true}
                          onChange={() => localDispatch.onItemCheckboxClick(item)}
                        />
                      )}
                    />
                    <Column
                      sortable
                      field="sequencia"
                      style={tableCellCentered(120)}
                      header="Sequencia"
                    />
                    <Column sortable field="endereco" header="Endereço" />
                    <Column field="capacidade" style={tableCellCentered(120)} header="Capacidade" />
                    <Column
                      header="Expedição"
                      style={tableCellCentered(150)}
                      body={posicao => TrueOrFalseIconSetter(posicao.expedicaoName)}
                    />
                    <Column
                      header="Inventario"
                      style={tableCellCentered(150)}
                      body={posicao => TrueOrFalseIconSetter(posicao.inventarioName)}
                    />
                    <Column
                      style={tableCellCentered(120)}
                      body={posicao => BadgeStatusPosition(posicao)}
                      header="Status"
                    />
                    <Column
                      style={tableCellCentered(120)}
                      body={posicao => BadgeOcupationPosition(posicao)}
                      header="Ocupação"
                    />
                    <Column
                      field="companies"
                      header="Empresa(s)"
                      body={posicao => posicao.companies || '-'}
                    />
                  </DataTable>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Bloqueio - Posição" disabled={!selectedTp}>
            <div style={{ marginTop: 20 }}>
              <div className="p-grid">
                <div className="p-col-12 p-grid">
                  <div className="p-col-2" style={{ marginTop: 35 }}>
                    <div style={{ marginLeft: 10 }}>
                      <CustomCheckbox
                        disabled={!selectedTp || !state.selectedEstoque}
                        checked={state.selecionarTodos}
                        onChange={localDispatch.onSelecionarTodosChange}
                      >
                        Selecionar Todos
                      </CustomCheckbox>
                    </div>
                  </div>
                  <div className="p-col-3" style={{ marginTop: 10 }}>
                    <CustomDropdown
                      label={'Motivo de Bloqueio'}
                      options={state.motivos}
                      optionLabel={'name'}
                      onChange={value => localDispatch.onChange('selectedMotivo', value)}
                      value={state.selectedMotivo}
                    />
                  </div>
                  <div className="p-col-5">
                    <CustomInputTextArea
                      label={'Justificativa de Bloqueio'}
                      onChange={value => localDispatch.onChange('justificativa', value)}
                      value={state.justificativa}
                      rows={4}
                    />
                  </div>
                  <div className="p-col-2" style={{ marginTop: 40 }}>
                    <Btn onClick={() => localDispatch.onClickBloquear()}> Bloquear </Btn>
                  </div>
                </div>
                <div className="p-col-12">
                  <DataTable
                    value={state.posicoes}
                    emptyMessage="Não existe posição cadastrada"
                    loading={state.isLoading}
                    rows={10}
                    paginator={true}
                    header={
                      <CustomDataTableHeader
                        onChange={value => localDispatch.onChange('globalFilterBloqueio', value)}
                      >
                        <div style={{ display: 'inline-flex', marginLeft: 20 }}>
                          <Btn onClick={() => localDispatch.onClickDesbloquear()}>
                            {' '}
                            Desbloquear{' '}
                          </Btn>
                        </div>
                      </CustomDataTableHeader>
                    }
                    globalFilter={state.globalFilterBloqueio}
                  >
                    <Column
                      header="#"
                      style={tableCellCentered(80)}
                      body={item => (
                        <CustomCheckbox
                          checked={item.selected === true}
                          onChange={() => localDispatch.onItemCheckboxClick(item)}
                        />
                      )}
                    />
                    <Column
                      sortable
                      field="sequencia"
                      style={tableCellCentered(120)}
                      header="Sequencia"
                    />
                    <Column sortable field="endereco" header="Endereço" />
                    <Column
                      field="motivo_bloqueio"
                      style={tableCellCentered(300)}
                      header="Motivo"
                    />
                    <Column
                      style={tableCellCentered(120)}
                      body={posicao => BadgeStatusPosition(posicao)}
                      header="Status"
                    />
                    <Column
                      style={tableCellCentered(120)}
                      body={posicao => BadgeOcupationPosition(posicao)}
                      header="Ocupação"
                    />
                    <Column
                      field="companies"
                      header="Empresa(s)"
                      body={posicao => posicao.companies || '-'}
                    />
                    <Column
                      header=""
                      style={tableCellCentered(70)}
                      body={posicao => (
                        <TextBtn
                          onClick={item => localDispatch.onMenuItemClicked(posicao, selectedTp)}
                        >
                          <i
                            style={{ border: '1px solid #14B0BF', borderRadius: '100%' }}
                            className="pi pi-info"
                          ></i>
                        </TextBtn>
                      )}
                    />
                  </DataTable>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Bloqueio - Pallet" disabled={!selectedTp}>
            <div style={{ marginTop: 20 }}>
              <div className="p-grid">
                {state.selectedPosicaoEstoque && (
                  <div className="p-col-12">
                    <h4>Pallets da Posição: {state.selectedPosicaoEstoque.endereco}</h4>
                    <DataTable
                      value={state.pallets}
                      emptyMessage="Não existem pallets nesta posição"
                      loading={state.isLoading}
                      rows={10}
                      paginator={true}
                      selectionMode="single"
                      onSelectionChange={e => localDispatch.onPalletRowClick(e.value)}
                      style={{ cursor: 'pointer' }}
                      header={
                        <CustomDataTableHeader
                          onChange={value => localDispatch.onChange('globalFilterPallet', value)}
                        />
                      }
                      globalFilter={state.globalFilterPallet}
                    >
                      <Column
                        field="id"
                        header="Etiqueta"
                        style={tableCellCentered(120)}
                        sortable
                      />
                      <Column
                        field="picking_id"
                        header="Picking"
                        style={tableCellCentered(120)}
                        sortable
                      />
                      <Column
                        field="qte_caixas"
                        header="Caixas"
                        style={tableCellCentered(100)}
                        sortable
                      />
                      <Column
                        field="status_estoque"
                        header="Estoque - Status"
                        style={tableCellCentered(150)}
                        body={pallet => pallet.status_estoque || '-'}
                      />
                      <Column
                        field="status_estoque_grupo"
                        header="Estoque - Grupo"
                        style={tableCellCentered(150)}
                        body={pallet => {
                          if (!pallet.status_estoque_grupo) return '-'
                          const status = PalletAreaStatus(pallet.status_estoque_grupo)
                          if (status) {
                            return <Badge color={status.color}>{status.label}</Badge>
                          }
                          return pallet.status_estoque_grupo
                        }}
                      />
                    </DataTable>
                  </div>
                )}
                {!state.selectedPosicaoEstoque && (
                  <div className="p-col-12" style={{ textAlign: 'center', marginTop: 50 }}>
                    <p>Selecione uma posição de estoque acima para visualizar os pallets</p>
                  </div>
                )}
              </div>
            </div>
          </TabPanel>
        </CustomTabView>
      </CustomPanel>
      <ModalHistorico
        onClose={() => localDispatch.onChange('showModalHistorico', false)}
        posicaoHistorico={state.posicaoHistorico}
        visible={state.showModalHistorico}
      />
      <ModalPallet
        selectedTp={selectedTp}
        onClose={() => localDispatch.onChange('showModalPallet', false)}
        pallet={state.selectedPallet}
        visible={state.showModalPallet}
        onSaved={() => localDispatch.getPalletsStatus(state.selectedPosicaoEstoque.id)}
      />
    </>
  )
}

export function BadgeOcupationPosition({ caixas }) {
  if (caixas) return <Badge color={colors.vermelho_hover}>Ocupado</Badge>
  else return <Badge color={colors.verde_hover}>Vazio</Badge>
}

export function BadgeStatusPosition({ status }) {
  if (status === 'Disponivel') return <Badge color={colors.verde_hover}>Disponivel</Badge>
  else return <Badge color={colors.vermelho_hover}>Bloqueado</Badge>
}

function ModalHistorico({ posicaoHistorico, visible, onClose }) {
  const [expandedRows, setExpandedRows] = useState(null)
  const [globalFilter, setGlobalFilter] = useState('')

  return (
    <CustomModal header={'Histórico'} isVisible={visible} width={500} onClose={onClose}>
      <div className="p-grid">
        <div className="p-col-12">
          <DataTable
            value={posicaoHistorico}
            emptyMessage="Não existe histórico"
            rows={5}
            paginator={true}
            expandedRows={expandedRows}
            onRowToggle={e => setExpandedRows(e.data)}
            dataKey="id"
            rowExpansionTemplate={PosicaoInfo}
            header={<CustomDataTableHeader onChange={setGlobalFilter}></CustomDataTableHeader>}
            globalFilter={globalFilter}
          >
            <Column field="name" style={tableCellCentered(300)} header="Motivo" />
            <Column field="created_at" style={tableCellCentered(100)} header="Data" />
            <Column field="justificativa" expander={true} style={{ width: '3em' }} />
          </DataTable>
        </div>
      </div>
    </CustomModal>
  )
}

function PosicaoInfo(historico) {
  return (
    <div className="p-grid">
      <div className="p-col-12" style={{ paddingLeft: 10 }}>
        <CustomInputTextArea
          label={'Justificativa'}
          disabled={true}
          rows={4}
          value={historico.justificativa ? historico.justificativa : ''}
        ></CustomInputTextArea>
      </div>
    </div>
  )
}

function ModalPallet({ pallet, visible, onClose, selectedTp, onSaved }) {
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  const [palletItens, setPalletItens] = useState([])
  const [palletsStatus, setPalletsStatus] = useState([])
  const [missingReasons, setMissingReasons] = useState([])

  const [currentStatusId, setCurrentStatusId] = useState(null)
  const [currentStatusLabel, setCurrentStatusLabel] = useState('-')
  const [currentGrupo, setCurrentGrupo] = useState('-')

  const [selectedStatus, setSelectedStatus] = useState(null)
  const [selectedMotivo, setSelectedMotivo] = useState(null)

  useEffect(() => {
    if (!visible || !pallet || !selectedTp) return
    setLoading(true)
    setErrorMessage(null)
    setSelectedStatus(null)
    setSelectedMotivo(null)

    const palletAreaId =
      pallet && pallet.pallet_area_id != null ? pallet.pallet_area_id : pallet ? pallet.id : null

    EstoqueHttp.getInfoPalletStatus(selectedTp, palletAreaId)
      .then(res => {
        const data = res || {}
        const itens = data.palletItens || []
        const statuses = data.pallets_status || []
        const reasons = data.missing_reasons || []

        setPalletItens(itens)
        setPalletsStatus(statuses)
        setMissingReasons(
          reasons.map(function (m) {
            return { ...m, label: m.sigla + ' - ' + m.descricao }
          }),
        )

        const firstItem = itens && itens.length > 0 ? itens[0] : null

        const statusIdAtual =
          pallet && pallet.status_estoque_id != null
            ? pallet.status_estoque_id
            : firstItem && firstItem.status_estoque_id != null
              ? firstItem.status_estoque_id
              : null

        const statusLabelAtual =
          pallet && pallet.status_estoque
            ? pallet.status_estoque
            : firstItem && firstItem.status_estoque
              ? firstItem.status_estoque
              : '-'

        const grupoAtual =
          pallet && pallet.status_estoque_grupo
            ? pallet.status_estoque_grupo
            : firstItem && firstItem.status_estoque_grupo
              ? firstItem.status_estoque_grupo
              : '-'

        setCurrentStatusId(statusIdAtual)
        setCurrentStatusLabel(statusLabelAtual || '-')
        setCurrentGrupo(grupoAtual || '-')
      })
      .catch(err =>
        setErrorMessage(
          err && err.message ? err.message : 'Falha ao carregar informações do pallet',
        ),
      )
      .finally(() => setLoading(false))
  }, [visible, pallet, selectedTp])

  const statusOptions = (
    currentStatusId
      ? palletsStatus.filter(function (s) {
          return s.id !== currentStatusId
        })
      : palletsStatus
  ).map(function (s) {
    return { ...s, label: s.status + ' - ' + s.grupo }
  })

  const isGrupoBloqueado = selectedStatus && selectedStatus.grupo === 'Bloqueado'
  const canSave =
    !!selectedStatus &&
    (selectedStatus.grupo === 'Liberado' || (isGrupoBloqueado && !!selectedMotivo))

  const onSalvar = () => {
    if (!canSave || saving) return
    setSaving(true)
    setErrorMessage(null)

    const userInfo = getUsuarioInfo()
    const userId = userInfo && userInfo.id != null ? userInfo.id : null

    const palletAreaId =
      pallet && pallet.pallet_area_id != null ? pallet.pallet_area_id : pallet ? pallet.id : null

    const body = {
      status_estoque_id: selectedStatus ? selectedStatus.id : null,
      missing_reason_id:
        selectedStatus && selectedStatus.grupo === 'Bloqueado'
          ? selectedMotivo
            ? selectedMotivo.id
            : null
          : null,
    }

    EstoqueHttp.savePalletAreaStatus(userId, palletAreaId, body)
      .then(() => {
        if (onSaved) onSaved()
        if (onClose) onClose()
      })
      .catch(err =>
        setErrorMessage(err && err.message ? err.message : 'Falha ao salvar status do pallet'),
      )
      .finally(() => setSaving(false))
  }

  return (
    <CustomModal header={'Alterar Status Pallet'} isVisible={visible} width={650} onClose={onClose}>
      <div className="p-grid">
        <div className="p-col-12">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <strong>Etiqueta:</strong>
            <span>{pallet ? pallet.id : '-'}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <strong>Status atual:</strong>
            <span>{currentStatusLabel}</span>
            {currentGrupo &&
              currentGrupo !== '-' &&
              (function () {
                const badge = PalletAreaStatus(currentGrupo)
                return badge ? <Badge color={badge.color}>{badge.label}</Badge> : null
              })()}
          </div>
        </div>

        {loading && (
          <div className="p-col-12" style={{ textAlign: 'center', padding: 10 }}>
            Carregando informações...
          </div>
        )}

        {!!errorMessage && !loading && (
          <div className="p-col-12" style={{ color: '#d32f2f', marginTop: 5 }}>
            {errorMessage}
          </div>
        )}

        {!loading && (
          <>
            <div className="p-col-12 p-md-6">
              <CustomDropdown
                label="Novo status"
                options={statusOptions}
                optionLabel="label"
                value={selectedStatus}
                onChange={setSelectedStatus}
                filter
              />
            </div>

            {isGrupoBloqueado && (
              <div className="p-col-12 p-md-6">
                <CustomDropdown
                  label="Motivo"
                  options={missingReasons}
                  optionLabel="label"
                  value={selectedMotivo}
                  onChange={setSelectedMotivo}
                  filter
                />
              </div>
            )}

            <div
              className="p-col-12"
              style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}
            >
              <Btn onClick={onClose} backgroundColor="#6b7280">
                Cancelar
              </Btn>
              <Btn onClick={onSalvar} disabled={!canSave} isLoading={saving}>
                Salvar
              </Btn>
            </div>

            <div className="p-col-12">
              <Fieldset legend="Items do Pallet" toggleable collapsed={true}>
                <DataTable value={palletItens} paginator rows={10} emptyMessage="Sem items">
                  <Column
                    field="product_code"
                    header="Código"
                    style={{ textAlign: 'center', width: 120 }}
                  />
                  <Column field="product_name" header="Produto" />
                  <Column field="company_name" header="Empresa" />
                  <Column
                    field="qte_biped"
                    header="Qtd"
                    style={{ textAlign: 'center', width: 120 }}
                  />
                </DataTable>
              </Fieldset>
            </div>
          </>
        )}
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CadastroPosicoesEstoque))
